import {postRequest} from "../../src/api/index.js";
import {
    AUTH_ERROR,
    AUTH_ROLE,
    AUTH_USER,
    CURRENT_USER,
    UPDATE_LOGO,
    HOME,
    TERMS_CONDITIONS_COMPLETED
} from "../../src/actions/types.js";
import {setTermsConditionsCompleted} from "./home.js";
import {CognitoError, messageFor, signIn} from "../cognito/index.js";

// Keeps our API token and the user after a sign-in, password or Cognito (the two answers are the same)
const storeSession = (dispatch, res) => {
    dispatch({
        type: 'RESET'
    });
    localStorage.clear();
    dispatch({type: AUTH_USER, payload: res.data});

    // Persist new RBAC fields when the backend provides them
    const userData = res.data.user;
    if (res.data.userType) userData.userType = res.data.userType;
    if (res.data.roleKey) userData.roleKey = res.data.roleKey;

    dispatch({type: CURRENT_USER, payload: userData});

    // Store in both sessionStorage (tab-isolated) and localStorage (persistence)
    sessionStorage.setItem("user", JSON.stringify(userData));
    sessionStorage.setItem("token", res.data.jwt);
    sessionStorage.setItem("expiresIn", new Date(res.data.expiresIn).getTime());
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", res.data.jwt);
    localStorage.setItem("expiresIn", new Date(res.data.expiresIn).getTime());
};

export const loginUser = async (data, cb) => async (
    dispatch
) => {
    try {
        const res = await postRequest(`/login`, "user", data, (status) => {
            return (status >= 200 && status < 300) || status === 400 || status === 500; // default
        });

        if (res.status === 500 || res.status === 400) {
            dispatch({
                type: AUTH_ERROR,
                payload: 'We are sorry. The username or password you used is incorrect.'
            });
        } else if (res.status !== 400) {
            storeSession(dispatch, res);
            cb();
        }
    } catch (err) {
        if (err && err?.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: AUTH_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: AUTH_ERROR,
                    payload: err.message
                });
            }
        } else if (err && err?.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: AUTH_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: AUTH_ERROR,
                payload: err?.message
            });
        } else {
            // Some other errors
            dispatch({
                type: AUTH_ERROR,
                payload: "Something went wrong."
            });
        }
        dispatch({
            type: AUTH_ERROR,
            payload: err && err?.response && err?.response?.data && err?.response?.data?.errors[0] ? err && err?.response && err?.response.data && err?.response?.data?.errors[0] : "Something went wrong"
    });
    }
};

/**
 * The Cognito sign-in (TO-1696): Cognito checks the password (the migrate trigger brings an existing
 * account over at its first sign-in), then POST /login/cognito trades the ID token for our token.
 * onResetRequired(userName) runs when the password must be replaced first (under 12 characters).
 */
export const loginUserWithCognito = async (data, cb, onResetRequired) => async (
    dispatch
) => {
    try {
        const idToken = await signIn(data.userName, data.password);
        const res = await postRequest(`/login/cognito`, "user", {idToken}, (status) => {
            return (status >= 200 && status < 300) || status === 400;
        });
        if (res.status === 400) {
            dispatch({type: AUTH_ERROR, payload: res.data?.errors?.[0] || "We are sorry. We couldn't sign you in."});
            return;
        }
        storeSession(dispatch, res);
        cb();
    } catch (err) {
        if (err instanceof CognitoError && err.code === "PasswordResetRequiredException" && onResetRequired) {
            onResetRequired(data.userName);
            return;
        }
        dispatch({
            type: AUTH_ERROR,
            payload: err instanceof CognitoError ? messageFor(err) : (err?.response?.data?.errors?.[0] || "Something went wrong.")
        });
    }
};
